import { render } from "./DeleteContact.vue?vue&type=template&id=fd068a14&scoped=true"
import script from "./DeleteContact.vue?vue&type=script&lang=js"
export * from "./DeleteContact.vue?vue&type=script&lang=js"

import "./DeleteContact.vue?vue&type=style&index=0&id=fd068a14&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd068a14"]])

export default __exports__